<template>
  <div>
    <customerBasicInfo
      :source="customerData"
      :list="companyBasicInfoList"
    />
    <payInfo
      :source="customerData"
      :list="companyPayList"
    />
    <Invoicing :data="customerData" />
    <recommender
      :source="customerData"
      :list="recommenderList"
    />
  </div>
</template>
<script>

import customerBasicInfo from '../../components/customerBasicInfo.vue'
import Invoicing from '../../components/Invoicing.vue'
import payInfo from '../../components/payInfo.vue'
import recommender from '../../components/recommender.vue'
import configFn from './config'
import commonConfigFn from '../../config'

export default {
  name: 'basicInfo',
  components: {
    customerBasicInfo,
    payInfo,
    recommender,
    Invoicing,
  },
  props: ['customerData'],
  data() {
    const { companyBasicInfoList, companyPayList } = configFn.call(this)
    const { recommenderList } = commonConfigFn.call(this)
    return {
      // 企业-客户基本信息
      companyBasicInfoList,
      // 企业-支付信息
      companyPayList,
      // 推荐人信息
      recommenderList,
    }
  },
  methods: {

  },

}
</script>

<style>

</style>
